import React from 'react';
import '../App.css';
import Headerappprivateadmin from './/headerappprivateadmin'
import { Bodyappempresasbody} from './/bodyappempresasbody'
import { Footerappprivateadmin } from './/footerappprivateadmin'
import withRouter from './/withRouter'
class Bodyappempresas extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
          if(this.props.params.loginToken == '')
          {
              window.location = ('/')
          }

  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivateadmin/>
        <Bodyappempresasbody />
        <Footerappprivateadmin/>
      </div>
    );
  }
}
export default withRouter(Bodyappempresas);